import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const FatArrowIcon = ({
  width = 17,
  color = 'black90',
  marginLeft,
  marginRight,
  containerSize,
  rotate,
}: DefaultIconProps & { rotate?: number }) => (
  <DefaultIconWrapper
    containerSize={containerSize}
    marginLeft={marginLeft}
    marginRight={marginRight}
    width={width}
    style={rotate ? { transform: `rotate(${rotate}deg)` } : undefined}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17">
      <g fill="none" fillRule="evenodd" stroke={getSemanticTextColor(color)} strokeLinecap="round" strokeWidth="2">
        <path d="M8.5 1v14.348M15.417 8.5L8.5 15.417 1.583 8.5" />
      </g>
    </svg>
  </DefaultIconWrapper>
);
